module.exports = __webpack_public_path__ + "img/ic_ycbl_ok.b0195c63.png";